import { useState } from 'react';

import { SignupForm } from './SignupForm';
import { SignupData } from '../types';
import { signUp, SignupError } from '../../api';

import { useAppDispatch } from '../../../store';
import { Button } from '../../ui/components/Button';
import { Modal } from '../../ui/components/Modal';
import { uiActions } from '../../ui/slice';

export const SignupModal = () => {
  const dispatch = useAppDispatch();
  const [error, setError] = useState<string>();

  const doSignup = ({ email, password1, password2 }: SignupData) => {
    setError(undefined);
    signUp(email, password1, password2, dispatch).then(
      () => {
        dispatch(uiActions.setCurrentModal(null));
      }
    ).catch(
      (e: SignupError) => setError(e.message)
    );
  };

  return (
    <Modal
      className='flex-col'
      height={60}
      modalKey='signup'
      width={30}
    >
      <div className='grow flex flex-col items-center justify-evenly'>
        <h2 className='text-center text-2xl mb-4'>Sign up</h2>
        <p>
          You can sign up to JustWords for free! No credit card required.
        </p>
        {
          error && (
            <p className='text-white bg-red-500 rounded-sm p-2 text-center'>
              {error}
            </p>
          )
        }
        <SignupForm
          onSubmit={doSignup}
        />

        <small className='block text-neutral-300 mt-2 px-4'>
          Free accounts have a limit on the number of songs they can store in the
          library, and do not synchronise the library between computers. You can
          subscribe to JustWords Premium to remove these restrictions.
        </small>
      </div>
      <Button
        grow={false}
        onClick={() => dispatch(uiActions.setCurrentModal({ modal: 'login' }))}
      >
        Have an account? Sign in!
      </Button>
    </Modal>
  );
};
